import i18n from './i18n'

// 封装session
export const session = (key, value) => {
	if (!value) {
		const temp = sessionStorage.getItem(key)
		if (temp && temp.indexOf('helpers-') === 0) {
			return JSON.parse(temp.split('helpers-')[1])
		} else {
			return temp
		}
	} else {
		if (typeof value === 'object' || Array.isArray(value)) {
			value = 'helpers-' + JSON.stringify(value)
		}
		return sessionStorage.setItem(key, value)
	}
}

// 全局统一报错提示
export function handleErr(msg) {
	global.$notify({
    type: 'danger',
    message: msg ? msg.toString() : '服务端错误'
  })
}

// 获取一个范围的随机数如 1- 99
export const random = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min
}

// 给数字小数点留两位，整数则为.00
export const formatNum = (str, noCent, noLimit) => {
	let newStr = ''
	let count = 0
	let minus = ''
	if (typeof str === 'number') {
		str = str.toString()
	}
	if (str) {
		if (str.indexOf('+') === 0) {
			const splitArr = str.split('+')
			str = splitArr[splitArr.length - 1].toString()
			minus = splitArr.length === 2 ? '+' : ''
		} else if (str.indexOf('-') > -1) {
			const splitArr = str.split('-')
			str = splitArr[splitArr.length - 1].toString()
			minus = splitArr.length === 2 ? '-' : ''
		}
	} else {
		str = '0'
	}
	if (str.indexOf('.') === -1) {
		for (let i = str.length - 1; i >= 0; i--) {
			if (count % 3 === 0 && count !== 0) {
				newStr = str.charAt(i) + ',' + newStr
			} else {
				newStr = str.charAt(i) + newStr
			}
			count++
		}
		str = minus + newStr + (noCent || noLimit ? '' : '.00')
	} else {
		for (let i = str.indexOf('.') - 1; i >= 0; i--) {
			if (count % 3 === 0 && count !== 0) {
				newStr = str.charAt(i) + ',' + newStr
			} else {
				newStr = str.charAt(i) + newStr
			}
			count++
		}
		if (noLimit) {
			str = minus + newStr + (str).substr((str).indexOf('.'))
		} else {
			str = minus + newStr + (str + '00').substr((str + '00').indexOf('.'), 3)
		}
	}
	return str
}

export const randomString = (len = 5) => {
	const char = 'ABCDEFGHIGKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'
	let randomStr = ''
	for (let i = 0; i < len; i++) {
		randomStr += char.charAt(Math.floor(Math.random() * 62))
	}
	return randomStr
}

// 数据对象空值过滤
export function filterQuery(data) {
	const query = { ...data }
	for (const key in query) {
		if (query[key] === '' || query[key] === undefined || query[key] === null) {
			delete query[key]
		}
	}
	return query
}

export function parseData(obj) {
  return JSON.parse(JSON.stringify(obj))
}

// 判断时间段显示对应问候语
export function getDayGreetings() {
	const hour = new Date().getHours()
	let hint = ''
  switch (true) {
		case (hour < 6):
			// 凌晨好
			hint = i18n.t('app.label.goodDawning')
			break
		case (hour < 9):
			// 早上好
			hint = i18n.t('app.label.goodMorning')
			break
		case (hour < 12):
			// 上午好
			hint = i18n.t('app.label.goodForenoon')
			break
		case (hour < 14):
			// 中午好
			hint = i18n.t('app.label.goodNoon')
			break
		case (hour < 17):
			// 下午好
			hint = i18n.t('app.label.goodAfternoon')
			break
		case (hour < 19):
			// 傍晚好
			hint = i18n.t('app.label.goodEvening')
			break
		case (hour < 22):
			// 晚上好
			hint = i18n.t('app.label.goodNight')
			break
		case (hour < 24):
			// 夜里好
			hint = i18n.t('app.label.goodNight1')
			break
		default:
			hint = ''
  }
	return hint
}

// 简单的深拷贝
function getType(arg) {
	return Object.prototype.toString.call(arg).replace(/\[object (.+)\]/, '$1')
}

export function cloneDeep(arg, map) {
	const typeID = ['Array', 'Object'].indexOf(getType(arg))
	if (typeID < 0) return arg
	const rtn = typeID ? {} : []
	map = map || new WeakMap()
	map.set(arg, rtn)
	Object.keys(arg).map(item => {
			if (map.has(arg[item])) {
					rtn[item] = map.get(arg[item])
			} else {
					rtn[item] = cloneDeep(arg[item], map)
			}
	})
	return rtn
}

// 分享给朋友
export function shareMessageToFriend (options) {
  window.wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
    window.wx.updateAppMessageShareData({
     ...options
    })
    window.wx.updateTimelineShareData({
      title: options.title, // 分享标题
      link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: options.imgUrl
    })
  })
}

export function downloadImage(imageUrl) {
  const link = document.createElement('a')
  link.href = imageUrl
  link.download = 'image.jpg' // 下载的图片名称
  link.click()
}
